import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import Login from './features/auth/Login'
import GridExplorer from './features/explorer/GridExplorer'
import Profile from './features/auth/Profile'
import PortfolioRoute from './features/portfolio/PortfolioRoute'
import ProjectDetail from './features/portfolio/ProjectDetail'
import PostPage from './features/portfolio/PostPage'
import PostEditor from './features/portfolio/PostEditor'
import Tuition from './features/tuition/Tuition'
import WorkProgressTracker from './features/work-progress/WorkProgressTracker'


// Protected Route Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-primary">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-singapore-red"></div>
      </div>
    )
  }
  
  return user ? <>{children}</> : <Navigate to="/login" replace />
}

function AppContent() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 dark:bg-dark-primary">
        <main className="flex-1">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route 
              path="/explorer" 
              element={
                <ProtectedRoute>
                  <GridExplorer />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route path="/about" element={<PortfolioRoute />} />
            <Route path="/about/work/:slug" element={<ProjectDetail />} />
            <Route path="/writing/:slug" element={<PostPage />} />
            <Route path="/editor" element={<PostEditor />} />
            <Route path="/tuition" element={<Tuition />} />
            <Route path="/work-progress" element={<WorkProgressTracker />} />
            <Route path="/" element={<Navigate to="/tuition" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
        <Analytics />
        <SpeedInsights />
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
